var EntitySelectComponent = (function () {
    function EntitySelectComponent() {
        this.toggleDropdown = false;
    }
    EntitySelectComponent.prototype.toggleEntity = function (entity) {
        this.toggleDropdown = false;
        entity.selected = !Boolean(entity.selected);
        this.notify();
    };
    EntitySelectComponent.prototype.clear = function () {
        var _a;
        (_a = this.entities) === null || _a === void 0 ? void 0 : _a.forEach(function (x) { x.selected = false; });
        this.toggleDropdown = false;
        this.notify();
    };
    EntitySelectComponent.prototype.getSelectedEntityTitles = function () {
        var _a;
        return (_a = this.entities) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return x.selected || false; }).map(function (x) { return x.title; }).join(', ');
    };
    EntitySelectComponent.prototype.notify = function () {
        if (this.onSelectionChange) {
            this.onSelectionChange({ selectedEntities: this.entities.filter(function (x) { return !!x.selected; }) });
        }
    };
    return EntitySelectComponent;
}());
export { EntitySelectComponent };
